import { render, staticRenderFns } from "./ModifySeedModal.vue?vue&type=template&id=526c51fe&scoped=true&"
import script from "./ModifySeedModal.vue?vue&type=script&lang=js&"
export * from "./ModifySeedModal.vue?vue&type=script&lang=js&"
import style0 from "./ModifySeedModal.vue?vue&type=style&index=0&id=526c51fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c51fe",
  null
  
)

export default component.exports